import Image from "next/image";
import Link from "next/link";
import { cn } from "@/lib/utils";

export function Logo({
  variant = "default",
  className,
  href = "/",
  priority = false,
}: {
  variant?: "default" | "onDark";
  className?: string;
  href?: string | null;
  priority?: boolean;
}) {
  const img = (
    <Image
      src="/logo/logo-transparent.small.png"
      alt="My Value Academy"
      width={80}
      height={44}
      quality={50}
      priority={priority}
      className={cn(
        "h-11 w-auto object-contain sm:h-12",
        variant === "onDark" && "h-14"
      )}
    />
  );

  if (variant === "onDark") {
    return (
      <div
        className={cn(
          "inline-flex items-center rounded-xl bg-cream px-3 py-1.5 shadow-soft",
          className
        )}
      >
        {img}
      </div>
    );
  }

  if (href === null) {
    return <span className={className}>{img}</span>;
  }

  return (
    <Link href={href} className={cn("inline-flex items-center", className)} aria-label="My Value Academy - home">
      {img}
    </Link>
  );
}
